import styled from 'styled-components';

const AdminMainContainer = styled.main`
  max-width: 1098px;
  margin: 0 auto;
  padding-top: 150px;
  padding-bottom: 41px;
  padding-left: 16px;
  padding-right: 16px;
`;
export default AdminMainContainer;
